export const HOURS_PER_YEAR = 365.25 * 24;

export const MAX_U64 = BigInt("18446744073709551615").toString();
